import { render } from "./ListeAlaUne.vue?vue&type=template&id=37f8cff0&ts=true"
import script from "./ListeAlaUne.vue?vue&type=script&lang=ts"
export * from "./ListeAlaUne.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__